import React, { useEffect, useState } from 'react';
import Navbar from '../components/navbar';
import Tab from '../components/AnalyticsTab';
import LineGraphControls from '../components/Dashboard/LineGraphControls';
import { fetchAllData } from '../components/Dashboard/helpers';
import Footer from '../components/Footer'

const HistoricalDataPage = () => {
  const [allData, setAllData] = useState(null);
  const [selectedStation, setSelectedStation] = useState(null); // should be null for initial

  useEffect(() => {
    // Fetch with status=Today on startup
    fetchAllData(setAllData, { status: 'All Time' });
  }, []);

  return (
    <div className="flex flex-col w-full bg-gradient-to-br from-blue-50 via-blue-100 to-blue-200 items-center" style={{ zoom: 0.8 }}>
      <header className="w-full content-center object-top sticky top-0 z-50">
        <Navbar/>
      </header>

      {/* Make container full width and responsive with less side margin */}
      <div className="w-full max-w-none px-0 sm:px-1 md:px-2 lg:px-4 xl:px-8 mb-4">
        {/* Enhanced label */}
        <div className="flex flex-col items-center mt-8 mb-6 px-2">
          <h1 className="text-lg sm:text-xl font-bold font-poppins text-blue-900 tracking-tight mb-2 drop-shadow-sm text-center">
            Data Monitoring &amp; Analytics
          </h1>
          <div className="h-1 w-16 bg-blue-500 rounded-full mb-2"></div>
          {/* Removed description text */}
        </div>
        {/* <Tab /> */}
        <div className="w-full bg-white/90 rounded-2xl shadow-xl p-2 sm:p-4 md:p-8">
          {allData ? (
            <div className="w-full">
              <LineGraphControls 
                allData={allData} 
                selectedStation={selectedStation} 
                setSelectedStation={setSelectedStation} 
              />
            </div>
          ) : (
            <div className="flex flex-col justify-center items-center h-[100dvh]">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-400 border-b-4 mb-4"></div>
              <p className="mt-2 text-blue-700 text-lg font-semibold">Fetching data...</p>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HistoricalDataPage;